export default __webpack_public_path__ + "static/media/bpg_mrgvlovani_caps_2010.bdc5ba1d.ttf";